import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import {createAttributeRoutePath} from 'src/modules/attributes/attributes-route-planner';
import {AttributeNameInfo} from 'src/openapi/models/AttributeNameInfo';

import Group from '@pb/kit-component-group';
import {MoreLessButton} from '@pb/kit-component-more-less';
import {Pill} from '@pb/kit-component-strip-of-pills';

import {attributePillsStrip} from './attribute-pills-strip.module.styl';

type Props = {
    attributesData: Array<AttributeNameInfo>,
};

export const AttributesPillsStrip = ({attributesData}: Props) => {
    const [showMoreButton, setShowMoreButton] = useState(true);
    const attributesToShow = showMoreButton ? attributesData.slice(0, 2) : attributesData;

    const onChange = () => {
        setShowMoreButton(prevState => !prevState);
    };

    return (
        <Group gap="xs" alignItems="center" wrap="wrap">
            {attributesToShow.map(attribute => (
                <Pill
                    key={attribute.id}
                    className={attributePillsStrip}
                    name={(
                        <Link
                            key={attribute.id}
                            to={createAttributeRoutePath({
                                attributeName: attribute.name,
                                attributeId: attribute.id,
                            })}>
                            {attribute.name}
                        </Link>
                    )}
                />
            ))}
            <MoreLessButton onChange={onChange} isCollapsed={showMoreButton}/>
        </Group>
    );
};
